import { Result } from "antd";
import Loader from "Common/Loader";
import DataGrid, {
  Column,
  Pager,
  Paging,
  SearchPanel,
  Summary,
  TotalItem,
} from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { getAllStoreOpsRoleData } from "pages/Componets/API_Modal";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import CreateStoreOperationModal from "./CreateStoreOperationModal";
import { StoreActionButtonsModal } from "./StoreActionButtonsModal";
import useHasPermission from "hooks/useHasPermission";

const StoreOperationDataList = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const hasPermission = useHasPermission();

  const dataSource = (): any | undefined => {
    return new CustomStore({
      key: "id",
      load: async (loadOptions) => {
        try {
          const search = JSON.parse(JSON.stringify(loadOptions));
          let parameterList = new URLSearchParams();
          for (const [key, value] of Object.entries(search)) {
            parameterList.append(key, JSON.stringify(value));
          }
          const response = await getAllStoreOpsRoleData(parameterList);
          return response;
        } catch (error) {
          console.error("Data loading error:", error);
          return { data: [], totalCount: 0 };
        }
      },
    });
  };

  const reloadDataSource = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0">Store Operation Role Master</h5>
              <CreateStoreOperationModal reloadDataSource={reloadDataSource} />
            </Card.Header>
            <Card.Body>
              {hasPermission("StoreOpsRole.Read") ? (
                <DataGrid
                  dataSource={dataSource()}
                  remoteOperations={{ groupPaging: true }}
                  showRowLines={true}
                  keyExpr="id"
                  key={refreshKey}
                  showBorders={true}
                  onContentReady={(e) => {
                    const hasData = e.component.totalCount() > 0;
                    e.component.option("pager.visible", hasData);
                    e.component.option("paging.visible", hasData);
                  }}
                >
                  <Paging defaultPageSize={10} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 25, 50, 100]}
                    showNavigationButtons={true}
                    displayMode="full"
                    showInfo={true}
                  />
                  <SearchPanel
                    visible={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Summary>
                    <TotalItem
                      column="firstName"
                      summaryType="count"
                      displayFormat="Total Store Ops Role: {0}"
                    />
                  </Summary>

                  {(hasPermission("StoreOpsRole.Write") ||
                    hasPermission("StoreOpsRole.Delete")) && (
                      <Column
                        caption="Action"
                        width="15%"
                        cssClass="text-center"
                        cellRender={({ data }) => (
                          <div className="d-flex justify-content-center align-items-center gap-2">
                            <StoreActionButtonsModal
                              selectedIdStoreId={data.id as string}
                              onDeleteSuccess={reloadDataSource}
                              onUpdateSuccess={reloadDataSource}
                              reloadDataSource={reloadDataSource}
                            />
                          </div>
                        )}
                      />
                    )}
                  <Column
                    dataField="id"
                    dataType="number"
                    sortOrder="desc"
                    visible={false}
                  />
                  <Column
                    dataField="roleName"
                    caption="Role Name"
                    dataType="string"
                  />
                </DataGrid>
              ) : (
                null
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default StoreOperationDataList;
